import React, { Component } from 'react'
import PropTypes from 'prop-types'

import './style.scss'

export default class Body extends Component {
    static propTypes = {
        text: PropTypes.element,
        title: PropTypes.element,
    }

    static defaultProps = {
        text: null,
        title: null,
    }

    render() {
        const { title, text } = this.props

        return (
            <div className={'toastr-message-body'}>
                <div className={'title'}>{title}</div>
                {title && text && <div className={'separator'} />}
                <div className={'text'}>{text}</div>
            </div>
        )
    }
}
